<rt-dialog-header
  [heading]="heading"
  [subheading]="
    'app.candidate.admin_select.share_with_team.confirm_dialog.subheading'
      | translate: { count: assignments.length }
  "
  [stepText]="'app.candidate.admin_select.step_2_of_2' | translate"
/>
<rt-dialog-body>
  <div layout-vertical layout-full-width>
    <rt-label margin-bottom-small-xx>
      {{ 'app.candidate.admin_select.share_with_team.confirm_dialog.share_with' | translate }}
    </rt-label>
    <rt-candidate-shared-with-list [sharedWithUsers]="$any(assignments)" />

    <rt-label margin-top margin-bottom-small-xx>
      {{ 'app.candidate.admin_select.share_with_team.confirm_dialog.message' | translate }}
      <rt-badge color="optional" [text]="'app.common.optional' | translate" margin-left-small-x />
    </rt-label>

    <rt-wysiwyg
      prosemirrorBasicConfig
      [formControl]="formControl"
      [withBorder]="true"
      [toolbarVisible]="true"
      [placeholder]="
        'app.candidate.admin_select.share_with_team.confirm_dialog.message_placeholder' | translate
      "
      layout-full-width
      data-cy="candidate-sharing-confirm-dialog:share-message"
    />
  </div>
</rt-dialog-body>
<rt-dialog-footer [hasOptionalActions]="true">
  <rt-button variant="plain" (click)="goBack()" class="optional">
    <rt-icon name="arrow-back" />
    {{ 'app.common.go_back' | translate }}
  </rt-button>
  <rt-button variant="plain" (click)="cancel()">
    {{ 'app.common.cancel' | translate }}
  </rt-button>
  <rt-button variant="primary" (click)="share()">
    {{ 'app.common.share' | translate }}
  </rt-button>
</rt-dialog-footer>
